<template>
  <v-select
    v-model="selected"
    :items="allActiveNonSystemEvents"
    item-value="id"
    item-text="label"
    attach
    outlined
    dense
    :multiple="multiple"
    clearable
    :label="label ? label : 'Event'"
    @change="$emit('select-item', selected)"
  />
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      initEvent: {
        type: String,
        default: ''
      },
      initEvents: {
        type: Array,
        default: () => []
      },
      label: {
        type: String,
        default: ''
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.multiple
          ? (this.initEvents || [])
          : (this.initEvent || '')
      }
    },
    computed: {
      ...mapGetters([ 'allActiveNonSystemEvents' ])
    },
    watch: {
      initEvents() {
        this.selected = this.initEvents
      }
    },
    created() {
      this.$store.dispatch('initEvents')
    }
  }
</script>
